import React, { useState } from "react";

const sections = [
  {
    title: "Información Personal",
    content: (
      <>
        <p className="break-words">
          <strong>Nombre:</strong> Karolis Tamosaitis Kembre
        </p>
        <p className="break-words">
          <strong>Email:</strong> ktamosaxlv@gmail.com
        </p>
      </>
    ),
  },
  {
    title: "Experiencia Laboral como desarrollador",
    content: (
      <ul className="mb-4 space-y-3 sm:space-y-4 sm:mb-6">
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-lg font-bold sm:text-xl">
            Desarrollador web full stack
          </h3>
          <p>
            <strong>Empresa:</strong> Tracasa
          </p>
          <p className="mb-1 sm:mb-2">
            <strong>Duración:</strong> Abril. 2023 - Octubre. 2024
          </p>
          <p>
            <strong>Cualidades aprendidas:</strong>
          </p>
          <ul className="ml-2 list-disc list-inside">
            <li>
              Diseño y desarrollo de páginas web responsivas, dinámicas y
              funcionales.
            </li>
            <li>
              Programación de código para implementar nuevas funcionalidades o
              solucionar bugs.
            </li>
            <li>
              Presentación de proyectos y soporte en la toma de decisiones para
              resolver problemas.
            </li>
            <li>
              Aplicación de metodologías ágiles en la gestión de proyectos y
              trabajo en equipo.
            </li>
          </ul>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-lg font-bold sm:text-xl">
            Desarrollador web prestashop
          </h3>
          <p>
            <strong>Empresa:</strong> Agradaweb Digital Services
          </p>
          <p className="mb-1 sm:mb-2">
            <strong>Duración:</strong> enero. 2023 - abril. 2023
          </p>
          <p>
            <strong>Cualidades aprendidas:</strong>
          </p>
          <ul className="ml-2 list-disc list-inside">
            <li>
              Comunicación con clientes para comprender y desarrollar soluciones
              a sus necesidades.
            </li>
            <li>
              Conocimiento y análisis del funcionamiento de comercios
              electrónicos.
            </li>
            <li>Desarrollo de e-commerce utilizando Prestashop.</li>
          </ul>
        </li>
      </ul>
    ),
  },
  {
    title: "Experiencia Laboral general",
    content: (
      <ul className="space-y-3 sm:space-y-4">
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-lg font-bold sm:text-xl">
            Asesor de ventas en tecnología
          </h3>
          <p>
            <strong>Empresa:</strong> Carrefour
          </p>
          <p className="mb-1 sm:mb-2">
            <strong>Duración:</strong> Noviembre. 2021 - Enero. 2023
          </p>
          <p>
            <strong>Cualidades aprendidas:</strong>
          </p>
          <ul className="ml-2 list-disc list-inside">
            <li>
              Asesoramiento personalizado a clientes en la selección de
              electrodomésticos, equipos informáticos y dispositivos móviles.
            </li>
            <li>
              Gestión de inventario y reposición de productos en el área de
              tecnología.
            </li>
            <li>
              Manejo de técnicas de venta persuasiva para alcanzar y superar los
              objetivos comerciales.
            </li>
            <li>
              Conocimiento actualizado de tendencias tecnológicas y nuevos
              lanzamientos en el mercado.
            </li>
          </ul>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-lg font-bold sm:text-xl">Camarero y reponedor</h3>
          <p>
            <strong>Empresa:</strong> Sendaviva
          </p>
          <p className="mb-1 sm:mb-2">
            <strong>Duración:</strong> Septiembre. 2019 - Noviembre. 2021
          </p>
          <p>
            <strong>Cualidades aprendidas:</strong>
          </p>
          <ul className="ml-2 list-disc list-inside">
            <li>
              Brindar una atención amable y eficiente en la barra, asegurando
              que cada cliente tenga una experiencia agradable.
            </li>
            <li>
              Entregar bebidas y comidas con rapidez y precisión, cuidando la
              presentación y calidad de cada pedido.
            </li>
            <li>
              Preparar cafés, cócteles y otras especialidades del bar,
              manteniendo altos estándares de sabor y presentación.
            </li>
            <li>
              Encargarse de la reposición de productos, garantizando que siempre
              haya insumos disponibles para ofrecer un servicio fluido y de
              calidad.
            </li>
            <li>
              Preparar pedidos para las diferentes secciones de Sendaviva y
              transportarlos con furgoneta hasta el lugar de reposición.
            </li>
          </ul>
        </li>
      </ul>
    ),
  },
  {
    title: "Educación",
    content: (
      <ul className="space-y-3 sm:space-y-4">
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-lg font-bold sm:text-xl">
            Curso de ASP.Net + Angular
          </h3>
          <p>
            <strong>Institución:</strong> Inaem junto con IDIA
          </p>
          <p>
            <strong>Año:</strong> 2026
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-lg font-bold sm:text-xl">
            Grado superior en Desarrollo Web
          </h3>
          <p>
            <strong>Institución:</strong> IFP Planeta formación
          </p>
          <p>
            <strong>Año:</strong> 2024
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-lg font-bold sm:text-xl">
            Grado medio en sistemas microinformáticos y redes
          </h3>
          <p>
            <strong>Institución:</strong> CIP ETI Tudela
          </p>
          <p>
            <strong>Año:</strong> 2021
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-lg font-bold sm:text-xl">
            Formación secundaria obligatoria
          </h3>
          <p>
            <strong>Institución:</strong> IES Valle del Ebro
          </p>
          <p>
            <strong>Año:</strong> 2019
          </p>
        </li>
      </ul>
    ),
  },
  {
    title: "Habilidades técnicas",
    content: (
      <ul className="space-y-3 sm:space-y-4">
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">C#</h3>
          <p>
            <strong>Descripción:</strong> He aprendido a desarrollar
            aplicaciones utilizando C# y .NET en Tracasa desarrollando
            funcionalidades para Avantius y PSP en la área de justicia.
          </p>
          <p>
            <strong>Nivel:</strong> Intermedio
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">Angular</h3>
          <p>
            <strong>Descripción:</strong> He utilizado el framework de Angular
            para crear diferentes ventanas y componentes reutilizables para las
            diferentes aplicaciones de Tracasa.
          </p>
          <p>
            <strong>Nivel:</strong> Intermedio
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">React</h3>
          <p>
            <strong>Descripción:</strong> Utilicé React para desarrollar desde
            cero una plataforma web destinada a la gestión de contenidos
            formativos internos en Tracasa. La página web que estás visualizando
            también ha sido construida con React.
          </p>
          <p>
            <strong>Nivel:</strong> Intermedio
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">SQL</h3>
          <p>
            <strong>Descripción:</strong> He utilizado SQL para gestionar bases
            de datos en Tracasa, asegurando la integridad y eficiencia en el
            manejo de la información. También he usado SQL para crear
            aplicaciones web personales.
          </p>
          <p>
            <strong>Nivel:</strong> Avanzado
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">Figma</h3>
          <p>
            <strong>Descripción:</strong> He utilizado Figma para diseñar
            interfaces de usuario y prototipos para aplicaciones en Tracasa,
            facilitando la creación de nuevas pantallas con diseños atractivos y
            funcionales. También lo he usado a nivel personal para mis propios
            proyectos.
          </p>
          <p>
            <strong>Nivel:</strong> Avanzado
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">Azure DevOps</h3>
          <p>
            <strong>Descripción:</strong> He utilizado Azure DevOps para
            gestionar el ciclo de vida de desarrollo de software en Tracasa,
            facilitando la colaboración entre equipos y la implementación
            continua de aplicaciones.
          </p>
          <p>
            <strong>Nivel:</strong> Intermedio
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">PHP</h3>
          <p>
            <strong>Descripción:</strong> He utilizado PHP para desarrollar
            funcionalidades personalizadas, como un sistema de avisos
            automáticos por correo electrónico que notifica cuando un producto
            se queda sin stock en una tienda online.
          </p>
          <p>
            <strong>Nivel:</strong> Básico
          </p>
        </li>
      </ul>
    ),
  },
  {
    title: "Habilidades Sociales",
    content: (
      <ul className="space-y-3 sm:space-y-4">
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">Comunicación</h3>
          <p>
            <strong>Descripción:</strong> He desarrollado habilidades de
            comunicación efectiva a través de la colaboración en equipo y la
            interacción con clientes en Tracasa.
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">Trabajo en equipo</h3>
          <p>
            <strong>Descripción:</strong> He trabajado en múltiples proyectos,
            colaborando con diferentes equipos para lograr objetivos comunes.
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">Esfuerzo continuo</h3>
          <p>
            <strong>Descripción:</strong> He demostrado un esfuerzo continuo en
            mi desarrollo profesional, buscando siempre mejorar mis habilidades
            y aprender nuevas tecnologías.
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">
            Enfoque y resolución de problemas
          </h3>
          <p>
            <strong>Descripción:</strong> He desarrollado un enfoque analítico
            para la resolución de problemas, abordando desafíos técnicos de
            manera efectiva y colaborando con mi equipo para encontrar
            soluciones innovadoras.
          </p>
        </li>
        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
          <h3 className="text-base font-bold sm:text-lg">
            metodologías ágiles
          </h3>
          <p>
            <strong>Descripción:</strong> He desarrollado un enfoque ágil para
            la gestión de proyectos, utilizando metodologías como Scrum y Kanban
            para mejorar la colaboración y la eficiencia en el desarrollo de
            software.
          </p>
        </li>
      </ul>
    ),
  },
];

const Curriculum = () => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleSection = (idx) => {
    setOpenIndexes((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx],
    );
  };

  return (
    <div
      id="curriculum"
      className="p-4 mx-auto mb-12 text-white rounded-lg shadow-md sm:p-6 bg-gray-900/30 sm:mb-20 lg:max-w-full sm:max-w-2xl md:max-w-3xl"
    >
      <h1 className="mb-4 text-2xl font-bold text-center sm:text-3xl sm:mb-6">
        Mi Curriculum
      </h1>
      <div className="block lg:hidden">
        {sections.map((section, idx) => (
          <div key={section.title} className="mb-4 sm:mb-6">
            <button
              className="flex items-center justify-between w-full px-4 py-3 font-semibold text-left bg-gray-800 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => toggleSection(idx)}
              aria-expanded={openIndexes.includes(idx)}
            >
              <span>{section.title}</span>
              <span className="ml-2">
                {openIndexes.includes(idx) ? "▲" : "▼"}
              </span>
            </button>
            <div
              className={`transition-all duration-300 ease-in-out overflow-hidden ${
                openIndexes.includes(idx) ? "max-h-[2000px] mt-2" : "max-h-0"
              }`}
            >
              <div className="px-2">{section.content}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="hidden lg:block">
        <section className="mb-4 sm:mb-6">
          <h2 className="mb-2 text-xl font-semibold sm:text-2xl sm:mb-4">
            Información Personal
          </h2>
          <p className="break-words">
            <strong>Nombre:</strong> Karolis Tamosaitis Kembre
          </p>
          <p className="break-words">
            <strong>Email:</strong> ktamosaxlv@gmail.com
          </p>
        </section>
        <section className="mb-4 sm:mb-6">
          <h2 className="mb-2 text-xl font-semibold sm:text-2xl sm:mb-4">
            Experiencia Laboral como desarrollador
          </h2>
          <ul className="mb-4 space-y-3 sm:space-y-4 sm:mb-6">
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-lg font-bold sm:text-xl">
                Desarrollador web full stack
              </h3>
              <p>
                <strong>Empresa:</strong> Tracasa
              </p>
              <p className="mb-1 sm:mb-2">
                <strong>Duración:</strong> Abril. 2023 - Octubre. 2024
              </p>
              <p>
                <strong>Cualidades aprendidas:</strong>
              </p>
              <ul className="ml-2 list-disc list-inside">
                <li>
                  Diseño y desarrollo de páginas web responsivas, dinámicas y
                  funcionales.
                </li>
                <li>
                  Programación de código para implementar nuevas funcionalidades
                  o solucionar bugs.
                </li>
                <li>
                  Presentación de proyectos y soporte en la toma de decisiones
                  para resolver problemas.
                </li>
                <li>
                  Aplicación de metodologías ágiles en la gestión de proyectos y
                  trabajo en equipo.
                </li>
              </ul>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-lg font-bold sm:text-xl">
                Desarrollador web prestashop
              </h3>
              <p>
                <strong>Empresa:</strong> Agradaweb Digital Services
              </p>
              <p className="mb-1 sm:mb-2">
                <strong>Duración:</strong> enero. 2023 - abril. 2023
              </p>
              <p>
                <strong>Cualidades aprendidas:</strong>
              </p>
              <ul className="ml-2 list-disc list-inside">
                <li>
                  Comunicación con clientes para comprender y desarrollar
                  soluciones a sus necesidades.
                </li>
                <li>
                  Conocimiento y análisis del funcionamiento de comercios
                  electrónicos.
                </li>
                <li>Desarrollo de e-commerce utilizando Prestashop.</li>
              </ul>
            </li>
          </ul>
          <h2 className="mb-2 text-xl font-semibold sm:text-2xl sm:mb-4">
            Experiencia Laboral general
          </h2>
          <ul className="space-y-3 sm:space-y-4">
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-lg font-bold sm:text-xl">
                Asesor de ventas en tecnología
              </h3>
              <p>
                <strong>Empresa:</strong> Carrefour
              </p>
              <p className="mb-1 sm:mb-2">
                <strong>Duración:</strong> Noviembre. 2021 - Enero. 2023
              </p>
              <p>
                <strong>Cualidades aprendidas:</strong>
              </p>
              <ul className="ml-2 list-disc list-inside">
                <li>
                  Asesoramiento personalizado a clientes en la selección de
                  electrodomésticos, equipos informáticos y dispositivos
                  móviles.
                </li>
                <li>
                  Gestión de inventario y reposición de productos en el área de
                  tecnología.
                </li>
                <li>
                  Manejo de técnicas de venta persuasiva para alcanzar y superar
                  los objetivos comerciales.
                </li>
                <li>
                  Conocimiento actualizado de tendencias tecnológicas y nuevos
                  lanzamientos en el mercado.
                </li>
              </ul>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-lg font-bold sm:text-xl">
                Camarero y reponedor
              </h3>
              <p>
                <strong>Empresa:</strong> Sendaviva
              </p>
              <p className="mb-1 sm:mb-2">
                <strong>Duración:</strong> Septiembre. 2019 - Noviembre. 2021
              </p>
              <p>
                <strong>Cualidades aprendidas:</strong>
              </p>
              <ul className="ml-2 list-disc list-inside">
                <li>
                  Brindar una atención amable y eficiente en la barra,
                  asegurando que cada cliente tenga una experiencia agradable.
                </li>
                <li>
                  Entregar bebidas y comidas con rapidez y precisión, cuidando
                  la presentación y calidad de cada pedido.
                </li>
                <li>
                  Preparar cafés, cócteles y otras especialidades del bar,
                  manteniendo altos estándares de sabor y presentación.
                </li>
                <li>
                  Encargarse de la reposición de productos, garantizando que
                  siempre haya insumos disponibles para ofrecer un servicio
                  fluido y de calidad.
                </li>
                <li>
                  Preparar pedidos para las diferentes secciones de Sendaviva y
                  transportarlos con furgoneta hasta el lugar de reposición.
                </li>
              </ul>
            </li>
          </ul>
        </section>
        <section className="mb-4 sm:mb-6">
          <h2 className="mb-2 text-xl font-semibold sm:text-2xl sm:mb-4">
            Educación
          </h2>
          <ul className="space-y-3 sm:space-y-4">
                        <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-lg font-bold sm:text-xl">
                Curso de ASP.Net + Angular
              </h3>
              <p>
                <strong>Institución:</strong> Inaem junto con IDIA
              </p>
              <p>
                <strong>Año:</strong> 2026
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-lg font-bold sm:text-xl">
                Grado superior en Desarrollo Web
              </h3>
              <p>
                <strong>Institución:</strong> IFP Planeta formación
              </p>
              <p>
                <strong>Año:</strong> 2024
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-lg font-bold sm:text-xl">
                Grado medio en sistemas microinformáticos y redes
              </h3>
              <p>
                <strong>Institución:</strong> CIP ETI Tudela
              </p>
              <p>
                <strong>Año:</strong> 2021
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-lg font-bold sm:text-xl">
                Formación secundaria obligatoria
              </h3>
              <p>
                <strong>Institución:</strong> IES Valle del Ebro
              </p>
              <p>
                <strong>Año:</strong> 2019
              </p>
            </li>
          </ul>
        </section>
        <section className="mb-4 sm:mb-6">
          <h2 className="mb-2 text-xl font-semibold sm:text-2xl sm:mb-4">
            Habilidades técnicas
          </h2>
          <ul className="space-y-3 sm:space-y-4">
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">C#</h3>
              <p>
                <strong>Descripción:</strong> He aprendido a desarrollar
                aplicaciones utilizando C# y .NET en Tracasa desarrollando
                funcionalidades para Avantius y PSP en la área de justicia.
              </p>
              <p>
                <strong>Nivel:</strong> Intermedio
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">Angular</h3>
              <p>
                <strong>Descripción:</strong> He utilizado el framework de
                Angular para crear diferentes ventanas y componentes
                reutilizables para las diferentes aplicaciones de Tracasa.
              </p>
              <p>
                <strong>Nivel:</strong> Intermedio
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">React</h3>
              <p>
                <strong>Descripción:</strong> Utilicé React para desarrollar
                desde cero una plataforma web destinada a la gestión de
                contenidos formativos internos en Tracasa. La página web que
                estás visualizando también ha sido construida con React.
              </p>
              <p>
                <strong>Nivel:</strong> Intermedio
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">SQL</h3>
              <p>
                <strong>Descripción:</strong> He utilizado SQL para gestionar
                bases de datos en Tracasa, asegurando la integridad y eficiencia
                en el manejo de la información. También he usado SQL para crear
                aplicaciones web personales.
              </p>
              <p>
                <strong>Nivel:</strong> Avanzado
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">Figma</h3>
              <p>
                <strong>Descripción:</strong> He utilizado Figma para diseñar
                interfaces de usuario y prototipos para aplicaciones en Tracasa,
                facilitando la creación de nuevas pantallas con diseños
                atractivos y funcionales. También lo he usado a nivel personal
                para mis propios proyectos.
              </p>
              <p>
                <strong>Nivel:</strong> Avanzado
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">Azure DevOps</h3>
              <p>
                <strong>Descripción:</strong> He utilizado Azure DevOps para
                gestionar el ciclo de vida de desarrollo de software en Tracasa,
                facilitando la colaboración entre equipos y la implementación
                continua de aplicaciones.
              </p>
              <p>
                <strong>Nivel:</strong> Intermedio
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">PHP</h3>
              <p>
                <strong>Descripción:</strong> He utilizado PHP para desarrollar
                funcionalidades personalizadas, como un sistema de avisos
                automáticos por correo electrónico que notifica cuando un
                producto se queda sin stock en una tienda online.
              </p>
              <p>
                <strong>Nivel:</strong> Básico
              </p>
            </li>
          </ul>
        </section>
        <section className="mb-4 sm:mb-6">
          <h2 className="mb-2 text-xl font-semibold sm:text-2xl sm:mb-4">
            Habilidades sociales
          </h2>
          <ul className="space-y-3 sm:space-y-4">
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">Comunicación</h3>
              <p>
                <strong>Descripción:</strong> He desarrollado habilidades de
                comunicación efectiva a través de la colaboración en equipo y la
                interacción con clientes en Tracasa.
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">
                Trabajo en equipo
              </h3>
              <p>
                <strong>Descripción:</strong> He trabajado en múltiples
                proyectos, colaborando con diferentes equipos para lograr
                objetivos comunes.
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">
                Esfuerzo continuo
              </h3>
              <p>
                <strong>Descripción:</strong> He demostrado un esfuerzo continuo
                en mi desarrollo profesional, buscando siempre mejorar mis
                habilidades y aprender nuevas tecnologías.
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">
                Enfoque y resolución de problemas
              </h3>
              <p>
                <strong>Descripción:</strong> He desarrollado un enfoque
                analítico para la resolución de problemas, abordando desafíos
                técnicos de manera efectiva y colaborando con mi equipo para
                encontrar soluciones innovadoras.
              </p>
            </li>
            <li className="p-3 bg-gray-800 rounded-lg shadow sm:p-4">
              <h3 className="text-base font-bold sm:text-lg">
                metodologías ágiles
              </h3>
              <p>
                <strong>Descripción:</strong> He desarrollado un enfoque ágil
                para la gestión de proyectos, utilizando metodologías como Scrum
                y Kanban para mejorar la colaboración y la eficiencia en el
                desarrollo de software.
              </p>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Curriculum;
